import classNames from "classnames";
import type { WireSwitchComponent } from "fluent-components/base-components";
import * as React from "react";
import tw from "twin.macro";
import { css } from "webapp/styled-components";
import { useWireValue as useWireEditableValue } from "webapp/wire-renderers/wire-lib";
import type { WireRenderer } from "webapp/wire-renderers/wire-renderer";

export const WireSwitch: WireRenderer<WireSwitchComponent> = React.memo(p => {
    const [checked, setChecked] = useWireEditableValue(p.value, p.backend);
    return (
        <label
            className={classNames(checked && "checked")}
            css={css`
                &.checked {
                    .thumb {
                        transform: translateX(14px);
                    }

                    .trough {
                        ${tw`bg-accent`}
                    }
                }
            `}
            tw="relative flex justify-between">
            <div tw="flex flex-col">
                <div tw="not-last:mb-1 text-sm text-text-contextual-dark">{p.title}</div>
                <div tw="text-xs text-text-contextual-xpale">{p.description}</div>
            </div>
            <div className="trough" tw="bg-n400A width[34px] h-5 relative rounded-full flex-shrink-0 ml-2">
                <div
                    className="thumb"
                    tw="bg-white rounded-full box-shadow[0px 4px 13px rgba(96, 96, 116, 0.1)] absolute left-0.5 top-0.5
                        w-4 h-4 ease-out transition transform translate-x-0"
                />
            </div>
            <input
                tw="absolute w-0 h-0 left-0 top-0"
                checked={checked}
                type="checkbox"
                onChange={e => setChecked?.(e.target.checked)}
            />
        </label>
    );
});
